import FollowAPI from "~/services/follow";
import useUserStore from "~/stores/user";
import getErrorLocalePathMessage from "~/utils/locale";

export default function useFollow(options: { id: string; type: TFollowType }) {
  const toaster = useToast();
  const { t, te } = useI18n();
  const userStore = useUserStore();
  const loading = ref(false);
  const isFollowing = computed(() => userStore.followed.has(options.id));
  const onError = (error: Error) => {
    const { message } = getErrorLocalePathMessage(error.message, { t, te });
    return toaster.error(message);
  };

  async function toggleFollow(item: TFollowItemType) {
    loading.value = true;

    if (isFollowing.value)
      await FollowAPI.unfollow(options.id).catch(onError);
    else
      await FollowAPI.follow({ item, type: options.type }).catch(onError);

    loading.value = false;
  }

  return { isFollowing, loading, toggleFollow };
}
